export default {
  props: {
    images: Array
  },
  render (h) {
    return h('div', this.images.map(function (image) {
      return h('a', {attrs: {href: image, target: '_blank'}}, [
        h('img', {attrs: {src: image}, class: 'civii-image'})
      ])
    }))
  }
}



// WEBPACK FOOTER //
// ./src/components/answers/Images/Images.js